import { Flex, Spinner } from "@chakra-ui/react";

import LiveTimelineView from "./LiveTimelineView";

export default function LiveTimeline({
  loading,
  session,
  monitoredAvatar,
  openEventView,
  toggleFreemiumFlow
}) {
  return (
    <>
      {loading ? (
        <Flex
          alignItems="center"
          justifyContent="center"
          width="100%"
          height="100%"
        >
          <Spinner />
        </Flex>
      ) : (
        <LiveTimelineView
          toggleFreemiumFlow={toggleFreemiumFlow}
          session={session}
          avatar={monitoredAvatar}
          openEventView={openEventView}
        />
      )}
    </>
  );
}
